var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 38",
    "aria-labelledby": "userIcon userDesc"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#f80032",
    strokeWidth: 1.5,
    cx: 19,
    cy: 19,
    r: 18.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 20.781c1.644 0 3.925.536 5.754 1.381 2.302 1.064 3.746 2.5 3.746 4.26 0 1.148-.93 2.078-2.078 2.078H11.578A2.078 2.078 0 019.5 26.422c0-1.76 1.444-3.196 3.746-4.26 1.829-.845 4.11-1.38 5.754-1.38zm0 1.782c-1.392 0-3.422.484-5.007 1.216-1.856.858-2.712 1.797-2.712 2.643 0 .164.133.297.297.297h14.844a.297.297 0 00.297-.297c0-.846-.856-1.785-2.712-2.643-1.585-.732-3.615-1.216-5.007-1.216zM19 9.5a4.75 4.75 0 110 9.5 4.75 4.75 0 010-9.5zm0 1.781a2.969 2.969 0 100 5.938 2.969 2.969 0 000-5.938z",
    fill: "#f80032"
  }))));
}

export default SvgUserRed;